<div *ngIf="uploadProperties && uploadFileVisibility">
  <ws10-upload-brix
  [uploadProperties]="uploadProperties"
  (encodedUploadFiles)="setUploadedFiles($event)"
  (uploadSuccess)="checkUploadStatus($event)"
  ></ws10-upload-brix>
</div>
